import { GeneralCatalogItem } from "@api/models/GeneralCatalogItem";
import { PROFILE_FIELDS_BASIC } from "@api/models/UserProfile";
import { MeetingRepository } from "@api/repositories/MeetingRepository";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { UserRepository } from "@api/repositories/UserRepository";
import { getIgnoringQueryObject } from "@service/helpers/exclusionGroupHelper";

export class PartnerDataLoader {
    constructor(
        public readonly schemaId: string,
        public readonly objectRepository: ObjectRepository,
        public readonly meetingRepository: MeetingRepository,
        public readonly userRepository: UserRepository
    ) {
    }

    async getItem(id: string, groups: string[]): Promise<GeneralCatalogItem | null> {

        const item = (
            await this.objectRepository.query<GeneralCatalogItem[]>(this.schemaId, {
                where: {
                    id: id,
                    isPublished: {
                        $in: [true, false]
                    },
                    groupIds: {
                        $containsAnyOrNullOrEmpty: groups
                    },
                },
                include: ['id', 'title', 'bannerFileId', 'iconFileId', 'parentId', 'description', 'tagsIds', 'ownerIds', 'webClientDescription',
                    'userProfileIds', 'addition', 'orderIndex', 'isOnline', 'onlineParams', 'fileIds', 'links', 'needContactsAgreement']
            })
        )[0] ?? null;

        return item
    }

    async getWebinar(id: string) {
        return await this.meetingRepository.schemaWebinar(this.schemaId, id)
    }

    async getRecommendedItems({ id, parentId, eventId, groups }: { parentId?: string; groups: string[]; id?: string; eventId?: string }) {
        const query = {
            take: -1,
            include: ['id', 'title', 'imageFileId', 'parentId', 'description',
                'orderIndex', 'isOnline', 'userProfileIds', 'tagsIds', 'onlineParams'],
            where: {
                parentId: parentId,
                groupIds: {
                    $containsAnyOrNullOrEmpty: groups
                },
                id: {
                    $ne: id
                },
                $or: [
                    {
                        eventId: {
                            $eq: eventId
                        }
                    },
                    {
                        eventId: {
                            $exists: false
                        }
                    }
                ]
            }
        }

        return await this.objectRepository.query<GeneralCatalogItem[]>(this.schemaId, query);
    }

    async getUserProfiles(profileIds: string[], ignoredGroupsIds: string[]) {
        return await this.userRepository.profiles({
            where: {
                id: {
                    "$in": profileIds
                },
                ...(getIgnoringQueryObject(ignoredGroupsIds))
            },
            include: PROFILE_FIELDS_BASIC,
            take: -1
        });
    }
}